import React, { useState } from 'react';
import { Card, Button } from './ui';
import { ShieldCheck, Plus, Minus, Scale, Clock, Lock, Zap, CreditCard } from 'lucide-react';
const CHECKOUT_URL = 'https://protocolo-reiki.impultienda.ar/checkout';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-185" data-mp="2wkmo6ben9krq">
      <div className="max-w-3xl mx-auto" data-id="element-186" data-mp="2wloc3ggre1qv">
        <Card className="bg-gradient-to-br from-slate-900 to-slate-800 border-brand-500/30 text-center relative overflow-hidden" data-id="element-187" data-mp="2wmr3dphzu67b">
          <div className="absolute -right-10 -top-10 text-brand-500/10" data-id="element-188" data-mp="3p9k7mhuldnm2">
            <ShieldCheck className="w-64 h-64" data-id="element-189" data-mp="3pbo80pta84hl" />
          </div>
          <div className="relative z-10" data-id="element-190" data-mp="3khai32xe2pkb">
            <ShieldCheck className="w-16 h-16 text-brand-400 mx-auto mb-6" data-id="element-191" data-mp="3fjih7jernt3z" />
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-192" data-mp="3fj8rzy1jppzc">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <p className="text-xl text-slate-300 mb-6" data-id="element-193" data-mp="c2s7oujz6xxj">
              Abrís los protocolos. Los aplicás a tu ritmo.
            </p>
            <p className="text-lg text-slate-400 mb-8" data-id="element-194" data-mp="2hke41cmnf8mu">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-195" data-mp="2ljvdeh574pxa" />
              <strong className="text-white" data-id="element-196" data-mp="2lk5281ei8r1e">devolución del 100%</strong>
              <br data-id="element-197" data-mp="27sgsu5vn4go4" />
              sin formularios, sin drama.
            </p>
            <p className="text-sm text-brand-400/80 font-medium" data-id="element-198" data-mp="2cs33q8nzxktr">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. El Megapack está explicado paso a paso para que puedas empezar de manera simple, incluso si es tu primera práctica energética.'
  }, {
    q: '¿Sirve si nunca practiqué Reiki?',
    a: 'Sí. Los protocolos están pensados para acompañarte desde cero con ejercicios claros, prácticas guiadas y una aplicación cotidiana posible.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Después de completar el pago recibís un email automático con el enlace de descarga en menos de 5 minutos. Podés verlo en el celular, la tablet o imprimirlo en casa.'
  }, {
    q: '¿Cuándo puedo empezar?',
    a: 'Podés empezar hoy mismo. El acceso es inmediato y cada protocolo está listo para que elijas el que más necesitás en este momento.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días completos sin preguntas. Si no estás satisfecho por cualquier motivo escribís a supportpuntodigital@gmail.com y te devolvemos el 100% del pago.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-199" data-mp="3vp7rh8fl1o8z">
      <div className="max-w-3xl mx-auto" data-id="element-200" data-mp="3qreospdhncdg">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8 flex items-center justify-center gap-3" data-id="element-201" data-mp="s27ghjojnp52">
          <span className="text-brand-400" data-id="element-202" data-mp="naz6alfe3zqu">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-203" data-mp="umvq1elpn667">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-800 rounded-xl bg-slate-900 overflow-hidden" data-id="element-204" data-mp="up03an5i1hj5" data-mpi={i}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-205" data-mp="14kjvaygxzw2m">
                <span className="font-bold text-white pr-8" data-id="element-206" data-mp="1dkghmtfv0iui">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-brand-400 shrink-0" data-id="element-207" data-mp="1ij9t6gbl5zs1" /> : <Plus className="w-5 h-5 text-slate-500 shrink-0" data-id="element-208" data-mp="1ncchoa1iaj1d" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-slate-400" data-id="element-209" data-mp="1sc8jq3qn80ea">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-12 px-4" data-id="element-210" data-mp="218pu34r6nu8z">
      <div className="max-w-4xl mx-auto" data-id="element-211" data-mp="2yz5jfo2zhtie">
        <div className="text-center mb-8" data-id="element-212" data-mp="2yxugtrl9yrsv">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-213" data-mp="2u1dvf55gmrjh">
            <Scale className="w-9 h-9 text-amber-400" data-id="element-214" data-mp="37r7hxgthszq1" /> ¿CUÁNTO CUESTA NO
            EMPEZAR HOY?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-215" data-mp="33r71jqmu2egc">
          <table className="w-full text-left border-collapse bg-slate-900 rounded-xl overflow-hidden" data-id="element-216" data-mp="2g0td0a3gixqi">
            <thead data-id="element-217" data-mp="2b2jdjnap9az3">
              <tr className="border-b border-slate-800 bg-slate-800/50" data-id="element-218" data-mp="2b31hz77imvi3">
                <th className="p-4 text-slate-300 font-medium" data-id="element-219" data-mp="2p2amvaq9u36r">
                  Sin una práctica diaria
                </th>
                <th className="p-4 text-red-400 font-bold" data-id="element-220" data-mp="2k1n0x3gwgcje">Costo real</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800" data-id="element-221" data-mp="49z2f3m8mbyh">
              <tr data-id="element-222" data-mp="3vicwztrlznza">
                <td className="p-4 text-slate-400" data-id="element-223" data-mp="3vgtgc221jawz">Dormir mal cada noche.</td>
                <td className="p-4 text-white font-medium" data-id="element-224" data-mp="7sy7domlnsas">
                  Cansancio que se acumula y menos energía para disfrutar tus
                  días
                </td>
              </tr>
              <tr data-id="element-225" data-mp="3u17jwkbf01j9">
                <td className="p-4 text-slate-400" data-id="element-226" data-mp="3u1ppi7jyvs3u">Seguir con ansiedad.</td>
                <td className="p-4 text-white font-medium" data-id="element-227" data-mp="2u4vu1qvibd9">
                  Vivir con la sensación de que todo te supera
                </td>
              </tr>
              <tr data-id="element-228" data-mp="qm23dgnaih8k">
                <td className="p-4 text-slate-400" data-id="element-229" data-mp="vj29frk53jzo">
                  Continuar cargando emociones del pasado.
                </td>
                <td className="p-4 text-white font-medium" data-id="element-230" data-mp="guxosi1j0ye9">
                  Postergar el cierre de etapas que ya necesitan sanar
                </td>
              </tr>
              <tr data-id="element-231" data-mp="19itkpkj9um9z">
                <td className="p-4 text-slate-400" data-id="element-232" data-mp="19ibhg3y6z7sk">
                  Absorber la energía de otras personas.
                </td>
                <td className="p-4 text-white font-medium" data-id="element-233" data-mp="1eabi5ym364q7">
                  Terminar cada día agotado y desconectado de vos
                </td>
              </tr>
              <tr data-id="element-234" data-mp="1j5xjp7ipgj1j">
                <td className="p-4 text-slate-400" data-id="element-235" data-mp="1j7gzkx0g8s2s">
                  Seguir sintiéndote bloqueado.
                </td>
                <td className="p-4 text-white font-medium" data-id="element-236" data-mp="1e5rojhd88eep">
                  Dejar en pausa la paz y la confianza que querés recuperar
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-237" data-mp="158hbprkrgh7o">
          <h3 className="text-2xl font-bold text-brand-400 mb-4" data-id="element-238" data-mp="10f63bm0avsdn">
            No importa cuál sea el problema que hoy estés viviendo.
            <br data-id="element-239" data-mp="vei9kskosxfq" />
            Dentro de este Megapack vas a encontrar un protocolo específico para empezar justamente por ese bloqueo.
          </h3>
          <blockquote className="text-xl text-slate-300 italic border-l-4 border-brand-500 pl-6 py-2 text-left" data-id="element-240" data-mp="mf51a38auewl">
            "La diferencia entre seguir cargando y volver a vos no es la suerte.
            Es darte un espacio para practicar todos los días."
          </blockquote>
        </div>

        {/* Final CTA Block */}
        <Card glow className="bg-slate-900 border-brand-500/50 text-center" data-id="element-241" data-mp="2y1p01srjwb7q">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 border border-red-500/20 px-4 py-2 rounded-full font-bold mb-8" data-id="element-242" data-mp="326evjgiarns4">
            <Clock className="w-5 h-5" data-id="element-243" data-mp="2adxoirdu427i" />
            EL PRECIO CIERRA EN: 23 hs : 59 min : 52 seg
          </div>

          <div className="grid md:grid-cols-1 gap-6 mb-8 max-w-md mx-auto" data-id="element-244" data-mp="2ef9ewz4j8rgr">
            <div className="p-6 border border-slate-700 rounded-xl bg-slate-800/50" data-id="element-245" data-mp="2ed6fjohhplzd">
              <h4 className="font-bold text-white mb-2" data-id="element-246" data-mp="2jcj1m70jep0w">
                PUNTO DIGITAL™ — MEGAPACK REIKI
              </h4>
              <p className="text-sm text-slate-400 mb-4" data-id="element-247" data-mp="1qpybf9vssiyx">
                6 Protocolos + 5 Bonos · Volvé a sentir paz
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-248" data-mp="1vnzvny4ymobz">
                <span className="text-slate-500 line-through text-sm" data-id="element-249" data-mp="p179lbmaw9z9">
                  $49.000
                </span>
                <span className="text-3xl font-black text-white" data-id="element-250" data-mp="k3nts79yfp57">$19.990</span>
                <span className="text-sm text-slate-400" data-id="element-251" data-mp="y2wzue4g52vg">ARS</span>
              </div>
              <Button className="w-full" variant="outline" onClick={() => {
              window.location.href = CHECKOUT_URL;
            }} data-id="element-252" data-mp="u11zpcy94vj9">
                QUIERO EMPEZAR MI PROTOCOLO
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-253" data-mp="1hqw9tmr6s5zt">
            <span className="flex items-center" data-id="element-254" data-mp="1crjq3avm3f1g">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-255" data-mp="1crtfoxcqvk6m" /> Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-256" data-mp="1qrm1qfdbtc89">
              <Zap className="w-4 h-4 mr-1 text-amber-400" data-id="element-257" data-mp="1ls9is5pkspay" /> Acceso en 5
              minutos
            </span>
            <span className="flex items-center" data-id="element-258" data-mp="25d9ma1nfyirn">
              <ShieldCheck className="w-4 h-4 mr-1 text-brand-400" data-id="element-259" data-mp="25bou2iolnbwy" /> Garantía 7
              días
            </span>
            <span className="flex items-center" data-id="element-260" data-mp="2aai606o8muv0">
              <CreditCard className="w-4 h-4 mr-1 text-brand-300" data-id="element-261" data-mp="1wc1um2ffkg6j" /> Mercado
              Pago | Tarjeta | Transferencia
            </span>
          </div>
        </Card>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-950 py-10 px-4 border-t border-slate-900" data-id="element-262" data-mp="1ml74uo2z6ygc">
      <div className="max-w-4xl mx-auto text-center" data-id="element-263" data-mp="1rfl451krdpqa">
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-264" data-mp="1cpdrj2hfn0xi">
          <span className="text-brand-400 font-bold tracking-widest uppercase" data-id="element-265" data-mp="1cn14iawti0dl">
            PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-slate-400 mb-4 max-w-2xl mx-auto" data-id="element-266" data-mp="13nw6d5p6491y">
          El Megapack Reiki para personas argentinas que quieren recuperar la
          calma, proteger su energía y volver a sentirse en paz.
        </p>
        <p className="text-slate-500 mb-8 italic" data-id="element-267" data-mp="348ykycrn2cgy">
          Porque tu energía también merece una práctica que te acompañe todos
          los días.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-slate-400 mb-12" data-id="element-268" data-mp="2v9bj5puzz4nd">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-brand-400 transition-colors" data-id="element-269" data-mp="307wm3x1mw2fi">
            supportpuntodigital@gmail.com
          </a>
          <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-270" data-mp="3rzu8gxp2alie">
            www.puntodigital.store
          </a>
        </div>

        <div className="text-xs text-slate-600 space-y-2" data-id="element-271" data-mp="3e7o1o27stqvm">
          <p data-id="element-272" data-mp="3j6r1n88x96wq">© Punto Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-273" data-mp="arh1i5olebrl">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-900" data-id="element-274" data-mp="fipc351ns36c">
          <p className="text-brand-500/50 font-medium italic" data-id="element-275" data-mp="fk0eb0fgh2vc">
            "Esta puede ser la semana en la que vuelvas a sentir paz."
          </p>
          <p className="text-slate-500 text-sm mt-2" data-id="element-276" data-mp="kw73ucnwrhwc">
            "Tu energía merece volver a sentirse en calma."
          </p>
        </div>
      </div>
    </footer>;
}